import customAxios from '../../plugins/axios.creator.plugin';

export const getByReferenceId = (referenceId) => {
    const response = customAxios().get(`/object/reference/${referenceId}`);
    return response
  }

